// extracted by mini-css-extract-plugin
export default {"signInContentContainer":"SignInPage_signInContentContainer__8FXvu","space":"SignInPage_space__1Mk3a","signInButton":"SignInPage_signInButton__r1doY"};